module.exports = __webpack_public_path__ + "static/media/logo-footer.9f70371e.svg";